import type { TFunction } from 'i18next';
import type {
  ChannelKind,
  PlanArea,
  ShareKind,
  TeamShares,
} from '../../api/workEnvironmentTypes';
import { WorkEnvironmentSurveyStatus } from '../../api/workEnvironmentTypes';
import { joinList } from '../HRDashboard/hmsFormat';

/** The result and the plan for the team, which opens without logging in */
export const teamPageLink = (origin: string, uuid: string) =>
  `${origin}/work-environment-team/${uuid}`;

/** «Teams og e-post» */
export const channelList = (channels: ChannelKind[], t: TFunction) =>
  joinList(
    channels.map((channel) => t(`workEnvironmentSharing.channels.${channel}`)),
    t,
    'and',
  );

export const lastShare = (data: TeamShares, kind: ShareKind) =>
  data.shares.find((share) => share.kind === kind) ?? null;

/** The result is shared once it is assessed. The later steps share the plan. */
export const sharesResult = (status: WorkEnvironmentSurveyStatus) =>
  status === WorkEnvironmentSurveyStatus.RISK_ASSESSED;

export const hasApprovedPlan = (areas: Pick<PlanArea, 'plan'>[]) =>
  areas.some((area) => Boolean(area.plan?.approved));

/** Whether the API allows sending it now is decided there. This only hides the button otherwise. */
export const canSend = (data: TeamShares, kind: ShareKind) =>
  data.canShare && data.channels.length > 0 && data.shareable.includes(kind);
